/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjUgOC41SDYuNVYwLjVIMC41VjguNVpNNS41IDcuNUgxLjVWMS41SDUuNVY3LjVaTTAuNSAxNS41SDYuNVYxMC41SDAuNVYxNS41Wk01LjUgMTQuNUgxLjVWMTEuNUg1LjVWMTQuNVpNMTUuNCAxNS41SDkuNVY3LjVIMTUuNFYxNS41Wk0xMC41IDE0LjVIMTQuNFY4LjVIMTAuNVYxNC41Wk05LjUgNS41SDE1LjRWMC41SDkuNVY1LjVaTTE0LjQgNC41SDEwLjVWMS41SDE0LjRWNC41WiIgZmlsbD0iaW5oZXJpdCIvPg==";